// extracted by mini-css-extract-plugin
export default {"customText":"ConditionalTooltipText__customText___ZLLwX"};